import React from 'react'
import ReactDOM from 'react-dom'

function VendedoresModal(props) {
    if (!props.isOpen) {
        return null
    }

    return ReactDOM.createPortal(
        <div
            className="modal d-flex align-items-center justify-content-center"
            tabIndex='-1'
            style={{ backgroundColor: 'rgba(0,0,0,0.5)', display: 'flex !important' }}
        >
            <div className="modal-dialog modal-dialog-centered modal-dialog-scrollable modal-md w-100">
                <div className="modal-content rounded-3 shadow-lg">

                    {/* HEADER */}
                    <div
                        className="modal-header px-4 py-3"
                        style={{ backgroundColor: '#01a59c' }}
                    >
                        <h5 className="modal-title fw-semibold text-white fs-5">
                            {props.title}
                        </h5>
                        <button className="close" onClick={props.onClose}>X</button>
                    </div>

                    {/* BODY */}
                    <div
                        className="modal-body px-4 py-3"
                        style={{ backgroundColor: '#84ede74d' }}
                    >
                        {props.children}
                    </div>

                    {/* FOOTER */}
                    <div
                        className="modal-footer px-4 py-3 d-flex justify-content-end gap-2"
                        style={{ backgroundColor: '#01a59c' }}
                    >
                        {/* <button className="btn btn-light btn-sm" onClick={props.onClose}>Cancelar</button> */}
                        {/* <button className="btn btn-dark btn-sm" onClick={props.onSubmit}>Aceptar</button> */}
                    </div>

                </div>
            </div>
        </div>,

        document.getElementById('modal')
    );
}

export default VendedoresModal